import { Component } from '@angular/core';
import { ReportsService } from '../../../Services/reports.service';
import { Subject, takeUntil } from 'rxjs';
import { UserType } from '../../../Shared/Enums/UserType';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import { UserInfoService } from '../../../Services/user-info.service';
import { DtoUserVM } from '../../../Model/Users/DtoUserVM';

@Component({
  selector: 'app-program-user-data',
  templateUrl: './program-user-data.component.html',
  styleUrl: './program-user-data.component.scss'
})
export class ProgramUserDataComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  AllUsers: DtoUserVM[] = [];
  currentPage: number = 0;
  pageSize: number = 10;
  totalItems: number = 0;

  constructor(private apiReport: ReportsService, private api: UserInfoService, private auth: AuthService,
    private spinner: NgxSpinnerService, private router: Router, private shared: SharedService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.GetAllUsers();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllUsers() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.api.GetProgramUserData(this.currentPage, this.pageSize)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          this.AllUsers = response.data;
          this.totalItems = response.totalItems;
          this.spinner.hide();
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  onPageChange(event: any): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.GetAllUsers();
  }

  DownLoadUsersExcelReport() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.apiReport.DownLoadUsersExcelReport()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.spinner.hide();
          this.shared.downloadBlobExcelFile(data, 'users');
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  DownLoadUsersPDFReport() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.apiReport.DownLoadUsersPDFReport()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.spinner.hide();
          this.shared.downloadBlobFile(data, 'UserInfo');
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
